import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import cn from 'classnames';
import { FC } from 'react';
import { FormState, useFormContext } from 'react-hook-form';

import { useUser } from '../../../hooks/useUser';
import { errorState } from '../auth.helps';
import { TypeForm } from '../auth.interface';

import styles from './AuthActions.module.sass';

interface IAuthActions {
  type: TypeForm;
}
// Кнопки
const AuthActions: FC<IAuthActions> = ({ type }) => {
  const { formState, getValues } = useFormContext();
  const { isLoading } = useUser();
  const isDisabled = errorState(formState); //Отключаем кнопку при разных условиях
  return (
    <>
      {(type === 'email' || type === 'phone') && (
        <LoadingButton
          className={cn(styles.button, {
            [styles.error]: isDisabled,
            [styles.disabled]: isDisabled || isLoading,
          })}
          loading={isLoading}
          loadingPosition="center"
          type="submit"
          variant="orange"
          fullWidth
          disabled={isDisabled || isLoading}
        >
          Получить код
        </LoadingButton>
      )}
      {type === 'code' && (
        <LoadingButton
          className={cn(styles.button, {
            [styles.error]: isDisabled,
            [styles.disabled]: isDisabled || isLoading,
          })}
          loading={isLoading}
          loadingPosition="center"
          type="submit"
          variant="orange"
          fullWidth
          disabled={isDisabled || isLoading}
        >
          Войти
        </LoadingButton>
      )}
    </>
  );
};

export default AuthActions;
